angular.module('tgaAdmin')
  .service('settingsService', ['$http', 'envService', 'domainService',
    function ($http, envService, domainService) {
      const serverAddress = envService.read('serverAddress');
      let settings = null;

      function destroy() {
        settings = null;
      }

      function getSettings() {
        if (!settings) {
          settings = $http({
            method: 'GET',
            url: `${serverAddress}settings`,
            params: {
              domain: domainService.domain,
            },
          }).then(
            (response) => response.data,
            (error) => {
              throw error.data;
            },
          );
        }

        return settings;
      }

      function updateSettings(data) {
        settings = $http({
          method: 'PUT',
          url: `${serverAddress}settings`,
          data: {
            settings: data,
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );

        return settings;
      }

      function generateLTI(data) {
        data.domain = domainService.domain;

        return $http({
          method: 'POST',
          url: `${serverAddress}settings/lti`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getDatePickerOptions(overrides, handlers) {
        const defaults = {
          clearable: false,
          opens: 'left',
          alwaysShowCalendars: true,
          showCustomRangeLabel: true,
          maxDate: moment().endOf('day'),
          locale: {
            format: 'M/D/YYYY',
            customRangeLabel: 'Custom',
          },
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            'Last 12 Months': [moment().subtract(12, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            'This Year': [moment().startOf('year'), moment()],
          },
          eventHandlers: handlers,
        };
        return _.merge({}, defaults, overrides);
      }

      return ({
        destroy,
        getSettings,
        updateSettings,
        generateLTI,
        getDatePickerOptions,
      });
    }]);
